import { render } from "./HeaderLogo.vue?vue&type=template&id=27387fe1&scoped=true&bindings={\"videoLoaded\":\"data\",\"videoRef\":\"data\",\"showLogo\":\"data\",\"activeSrc\":\"data\",\"inCareering\":\"options\",\"inRole\":\"options\"}"
import script from "./HeaderLogo.vue?vue&type=script&lang=js"
export * from "./HeaderLogo.vue?vue&type=script&lang=js"

import "./HeaderLogo.vue?vue&type=style&index=0&id=27387fe1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-27387fe1"

export default script